// extracted by mini-css-extract-plugin
export default {"paginatorButton":"paginatorButton__uBEF6"};